import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import TransactionEditForm from './transactionEditForm';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import TRANSACTION_EDIT_CONTROLLER from '../../controllers/transactionEdit';

import Logger, {LOG_LEVELS} from '../../utils/logger';
const log = new Logger('TRANSACTION_EDIT_PAGE', LOG_LEVELS.DEBUG);

class TransactionEdit extends Component {
  render() {
    log.debug('render(): ', this.props);

    let parsedQueryParams = QueryString.parse(this.props.location.search) || {};
    this.parsedQueryParams = parsedQueryParams;

    return(
      <div>
        <div className="clear"></div>
        <s-container>
          <h1 className="mb20"><LanguageStringResolver string="editTransaction_title"/></h1>
          {
            this.props.transaction ? (
              <TransactionEditForm
                transaction={this.props.transaction}
                submitHandler={this.doTransactionEdit.bind(this)}
                action={this.parsedQueryParams.action}
                />
            ) : (<div><LanguageStringResolver string="editTransaction_noData"/></div>)
          }
        </s-container>
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.onPageLoad(this.props.match.params.docId);
  }

  doTransactionEdit(formData, reason){
    log.debug('doTransactionEdit: formData: ', formData);
    log.debug('doTransactionEdit: reason: ', reason);
    formData.companies = this.props.companies;
    this.props.doAction( formData, this.parsedQueryParams.action, this.props.match.params.docId, reason);
    this.props.history.goBack();
  };

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);

  return {
    transaction: state.transaction && state.transaction.data,
    companies: state.companies && state.companies.data,
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (id) => {
      dispatch(TRANSACTION_EDIT_CONTROLLER.doLoad(id));
    },
    doAction: (formData, action, id, reason) => {
      dispatch(TRANSACTION_EDIT_CONTROLLER.doAction(formData, action, id, reason));
    },
  }
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(TransactionEdit);
